import React from "react";
import { DbrResult } from "../types";
import { COLORS } from "../constants";
import { formatValue } from "../hook/API";

/* =======================
   PROPS
======================= */

type Props = {
  data?: DbrResult;
};

/* =======================
   FIELD CONFIG
======================= */

type FieldConfig = {
  label: string;
  key: keyof DbrResult;
};

const DBR_FIELDS: FieldConfig[] = [
  // Basic Info
  { label: "Sector", key: "sector" },
  { label: "Dependents", key: "dependents" },

  // Amounts
  { label: "OFO Amount", key: "OFO_amt" },
  { label: "BMO Amount", key: "BMO_amt" },
  { label: "GMO Amount", key: "GMO_amt" },
  { label: "OMO Amount", key: "OMO_amt" },

  // DBR Values
  { label: "OFO DBR", key: "ofo_dbr" },
  { label: "BMO DBR", key: "bmo_dbr" },
  { label: "GMO DBR", key: "gmo_dbr" },
  { label: "OMO DBR", key: "omo_dbr" },

  // Maleem DBR
  { label: "Maleem OFO DBR", key: "maleem_ofo_dbr" },
  { label: "Maleem BMO DBR", key: "maleem_bmo_dbr" },
  { label: "Maleem GMO DBR", key: "maleem_gmo_dbr" },
  { label: "Maleem OMO DBR", key: "maleem_omo_dbr" },

  // Limits
  { label: "Max Maleem DBR", key: "Max_Maleem_dbr" },
];

/* =======================
   COMPONENT
======================= */

const SimahDBRView: React.FC<Props> = ({ data }) => {

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <table className="table text-left table-border spaced-table">
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>

        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {DBR_FIELDS.map(({ label, key }) => (
            <tr key={key}>
              <td>{label}</td>
              <td>{formatValue(data?.[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimahDBRView;
